import React from "react";
import sadFaceIcon from "../assets/iconFacePensive.svg";
import monocleFaceIcon from "../assets/iconFaceMonocle.svg";
export const DATA_TYPES = {
  COMMODITY: "COMMODITY",
  COMMODITY_BY_CODE: "COMMODITY_BY_CODE"
};
export const DEFAULT_SEARCH_QUERY = {
  searchString: "",
  searchPage: 1,
  searchPageSize: 15
};
export const DEFAULT_DATA = {
  [DATA_TYPES.COMMODITY]: {
    result: {
      levels: [],
      commodities: []
    },
    totalResults: 0
  },
  [DATA_TYPES.COMMODITY_BY_CODE]: {
    totalResults: 0,
    result: []
  }
};
export const GENERAL_ERROR_CONFIG = {
  icon: sadFaceIcon,
  header: "We have a little problem",
  message: "It looks like we encountered an issue when trying to display this information."
};
export const NO_DATA_ERROR_CONFIG = {
  icon: monocleFaceIcon,
  header: "No search results found",
  message: /*#__PURE__*/React.createElement(React.Fragment, null, "Sorry, but nothing matched your search criteria.", /*#__PURE__*/React.createElement("br", null), "Please try again with different or less specific keywords.")
};
export const HELP_INFO = [{
  name: "Commodity Code",
  content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "You will not be able to search for items that are prohibited within DPD UKs terms of carriage."), /*#__PURE__*/React.createElement("p", null, "For further help finding the correct code, please contact", " ", /*#__PURE__*/React.createElement("a", {
    href: "mailto: internationalexperts@dpdgroup.co.uk"
  }, "internationalexperts@dpdgroup.co.uk")))
}];